define(['angular'], function (angular) {
    'use strict';

    return angular.module('navDirectives', []).directive('navAccordian', [
        '$state',
        '$timeout',
        function ($state, $timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.find('[nav-accordian-state]').each(function () {
                        if ($(this).find('.subnav').length > 0) {
                            $(this).find('.nav-item').addClass('with-submenu');
                        } else {
                            $(this)
                                .find('.nav-item')
                                .removeClass('with-submenu');
                        }
                    });

                    element
                        .find('[nav-accordian-state] > a')
                        .click(function () {
                            var target = $(this).closest(
                                '[nav-accordian-state]'
                            );
                            if (target.find('.subnav').length > 0) {
                                target.toggleClass('current');

                                if (target.hasClass('current')) {
                                    target.siblings().removeClass('current');
                                }
                            }
                        });

                    var hoverTimeout = false;
                    element.find('[nav-accordian-state]').hover(
                        function () {
                            var $this = $(this);
                            if ($this.find('.subnav').length > 0) {
                                hoverTimeout = $timeout(function () {
                                    $this.addClass('current');
                                    $this.siblings().removeClass('current');
                                }, 500);
                            }
                        },
                        function () {
                            if (hoverTimeout) {
                                $timeout.cancel(hoverTimeout);
                            }
                        }
                    );

                    scope.$on('$stateChangeSuccess', function (
                        event,
                        current,
                        previous
                    ) {
                        element
                            .find('li[nav-accordian-state]')
                            .each(function () {
                                if (
                                    $state.includes(
                                        $(this).attr('nav-accordian-state')
                                    )
                                ) {
                                    $(this).addClass('current');
                                } else {
                                    $(this).removeClass('current');
                                }
                            });
                    });
                },
            };
        },
    ]);
});
